import { capitalizeName } from 'features/command-center/utils';
import startCase from 'lodash/startCase';
import moment from 'moment';
import { DateFormats } from 'UI/constants/defaults';
import { convertMinutesToSeconds, roundDecimals } from 'UI/utils';

export const formatResponse = response => {
  const formattedData = response.data.data.map(item => ({
    ...item,
    recruiterName: {
      empNo: item.empNo,
      name: capitalizeName(item?.recruiterName)
    },
    managerName: {
      managerEmpNo: item.managerEmpNo,
      team: item?.managerName
    },
    callsTime: item?.callsTime ? convertMinutesToSeconds(item?.callsTime) : 0,
    hireDate: item?.hireDate && moment(item?.hireDate).format(DateFormats.SimpleDate),
    lastPlacementDate:
      item?.lastPlacementDate && moment(item?.lastPlacementDate).format(DateFormats.SimpleDate),
    lastFeedbackActivityType:
      item?.lastFeedbackActivityType && startCase(item?.lastFeedbackActivityType),
    avgFeePercentage: item?.avgFeePercentage && roundDecimals(item?.avgFeePercentage, 2)
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};
